import {
  ALL_MODULES_METADATA_ERROR,
  ALL_MODULES_METADATA_REQUEST,
  ALL_MODULES_METADATA_SUCCESS,
} from "../../../actionTypes";
import { ModulesActionTypes } from "../../../types";

const initialState = false;

const isFetching = (
  state = initialState,
  action: ModulesActionTypes
): boolean => {
  switch (action.type) {
    case ALL_MODULES_METADATA_REQUEST:
      return true;

    case ALL_MODULES_METADATA_SUCCESS:
    case ALL_MODULES_METADATA_ERROR:
      return false;

    default:
      return state;
  }
};

export default isFetching;
